import commonScripts from './common';
import { initLottie } from './helpers/lottie';
import { initSliders } from './helpers/slider';
import { initFilters } from './helpers/filter';
import { initFacetFilters } from './helpers/facet-filter';
import { initHeader } from './helpers/header';
import { initAccordeons } from './helpers/accordeon';
import { initHorizontalScroll } from './helpers/horizontalScroll';
import initTabs from './helpers/tabs';
import { initModal } from './helpers/modal';
import { initTelCodeSelect } from './components/tel-code-select';
import { initSelect } from './components/select';

window.addEventListener('load', () => {
	commonScripts();
	initLottie();
	initHeader();
	initSliders();
	initTelCodeSelect();
	initSelect();
	initFilters();
	initFacetFilters();
	initAccordeons();
	initTabs();
	initHorizontalScroll();
	initModal();
});
